import { DotLoading, List, Modal, Popup, Tag } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import {
  getTodayDate,
  momentDate,
  NoData,
  timeTableDayFromNumber,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import TimeTableListItem from "./timeTableListItem";
import TimeTableListSubstitudeItem from "./timeTableListSubstituteItem";

const TodayTimeTable = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name",
    context.user.college_uuid
  );

  const [loader, setLoader] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataListSubstitude, setDataListSubstitude] = useState([]);

  const [generalData, setGeneralData] = useState([]);

  const [redirect, setRedirect] = useState([]);

  const [holiday, setHoliday] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const [semDate, setSemDate] = useState([]);
  const [todayDayOrder, setTodayDayOrder] = useState([]);

  const getAttendanceDate = () => {
    if (props.timeTableDate) return props.timeTableDate;
    let x = context.getStorage("mob_attendance_date");
    return x && x != null ? x : momentDate(new Date(), "YYYY-MM-DD");
  };

  const [attendanceDate, setAttendaceDate] = useState(getAttendanceDate());

  useEffect(() => {
    let m = context.getStorageByDate("dahboard_today_dayorder_value");
    if (m) setTodayDayOrder(m);
    let s = context.getStorageByDate("dahboard_today_timetable_value");
    if (s) setDataList(s);
  }, []);

  useEffect(() => {
    currentSemesterStartAndEndDate().then((res) => res && setSemDate(res));
    if (attendanceDate && attendanceDate != undefined) loadData();
  }, [attendanceDate]);

  const loadData = () => {
    setLoader(true);
    setHoliday([]);

    setDataListSubstitude([]);
    const form = new FormData();
    form.append("type", "today");
    form.append("date", attendanceDate); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("with_general", props.withGeneral ? "1" : "0");
    form.append("emp_uuid", context.user.uuid);
    form.append("college_uuid", context.user.college_uuid);
    form.append(
      "substitute",
      context.settingValue(
        "leave_with_substitute_approval",
        context.user.college_uuid
      )
    );
    axios.post(ServiceUrl.MOB.MY_TIME_TABLE, form).then((res) => {
      if (res["data"].status == "1") {
        context.setStorage(
          "dahboard_today_timetable_value",
          res.data.data,
          getTodayDate()
        );
        setDataList(res["data"].data);
        setGeneralData(res["data"].general);
        setDataListSubstitude(res["data"].substitude);
        if (res.data.day_order) {
          context.setStorage(
            "dahboard_today_dayorder_value",
            res.data.day_order,
            getTodayDate()
          );
          setTodayDayOrder(res.data.day_order);
        }
      } else {
        setDataList([]);
        if (res["data"].data) setHoliday(res["data"].data);
      }
      setLoader(false);
    });
  };

  const onDaySelect = () => {
    context.setStorage("mob_attendance_date", selectedDate);
    setAttendaceDate(selectedDate);
    setShowPopUp(false);
  };

  useEffect(() => {
    if (selectedDate && selectedDate.length > 2) {
      context.setStorage("mob_attendance_date", selectedDate);
      setAttendaceDate(selectedDate);
    }
    Modal.clear();
  }, [selectedDate]);

  const generalEntryClick = (special = false) => {
    if (special == "elective")
      navigate("/staff/app/custom-attendance-entry/elective");
    else if (special) navigate("/staff/app/custom-attendance-entry/special");
    else navigate("/staff/app/custom-attendance-entry");
  };

  const showDatePickerModal = () => {
    Modal.show({
      closeOnMaskClick: true,
      title: "Select Date",
      showCloseButton: true,
      content: (
        <div
          className="text-center "
          style={{ marginTop: "5px", padding: "5px" }}
        >
          <Form.Control
            type="date"
            max={momentDate(new Date(), "YYYY-MM-DD")}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
            min={semDate?.start_date}
          />
        </div>
      ),
    });
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg text-uppercase">
          <span className="fw-bold">
            {props.titleText || "Today's Time Table"}
          </span>
          <a className="float-end text-black fw-bold">
            {momentDate(attendanceDate, "DD-MMM-YYYY")}

            {todayDayOrder && todayDayOrder.day_order_value && (
              <>
                {" "}
                -{" "}
                <span
                  className="txt-day-order bg-theme px-1 py-0 text-white"
                  style={{ fontWeight: "10px" }}
                >
                  {todayDayOrder.day_order_text
                    ? todayDayOrder.day_order_text
                    : timeTableDayFromNumber(
                        todayDayOrder.day_order_value,
                        dayOrderInDayName
                      )}
                </span>
              </>
            )}

            {context.allowedAccess(
              "mob_older_att_view_calendar",
              "action_update"
            ) &&
              !props.upComing && (
                /*  context.user.college_uuid !=
                "eb0c5752-c7d9-4ae9-b2d1-78a80a8af6e2" && */ <Button
                  size="sm"
                  variant="light"
                  className="ms-2"
                  //onClick={(e) => setShowPopUp(true)}
                  onClick={(e) => showDatePickerModal(true)}
                >
                  <i className="fa-solid fa-calendar"></i>
                </Button>
              )}
          </a>
        </Card.Header>
        <Card.Body className="p-0">
          {loader && dataList.length < 1 && (
            <div className="text-center py-3 fs-4">
              <DotLoading />
            </div>
          )}

          {!loader && dataList.length < 1 && holiday.length < 1 && (
            <NoData imgWidth="130px" />
          )}
          {dataList && dataList.length > 0 && (
            <div class=" pb-2">
              <List>
                {dataList.map((item, i) => {
                  return (
                    <TimeTableListItem data={item} upComing={props.upComing} />
                  );
                })}
              </List>
            </div>
          )}

          {holiday && holiday.length > 0 && (
            <div className="text-center py-3 ">
              <span
                className="bg-theme-outlined fw-bold py-1 px-2 bg-color"
                style={{ fontSize: "14px" }}
              >
                {holiday[0].holiday_name}
              </span>
            </div>
          )}
        </Card.Body>
      </Card>
      {dataListSubstitude && dataListSubstitude.length > 0 && (
        <>
          <div className="section-heading d-flex align-items-center justify-content-between rtl-flex-d-row-r px-2 mt-2">
            <h6 className="text-uppercase">
              {"Today's Substitute Time Table"}
            </h6>
          </div>
          <div class=" pb-2">
            <List>
              {dataListSubstitude.map((item, i) => {
                return (
                  <TimeTableListSubstitudeItem
                    data={item}
                    upComing={props.upComing}
                  />
                );
              })}
            </List>
          </div>
        </>
      )}
      {generalData && generalData.length > 0 && (
        <>
          <div className="section-heading d-flex align-items-center mt-3 justify-content-between rtl-flex-d-row-r  text-uppercase">
            <h6>General Entries</h6>
          </div>

          <List>
            {generalData.map((item, i) => {
              item["attendace_marked_count"] = "1";
              return <TimeTableListItem data={item} />;
            })}
          </List>
        </>
      )}

      <Popup
        visible={showPopUp}
        showCloseButton
        onClose={() => {
          setShowPopUp(false);
        }}
        bodyStyle={{ height: "40vh" }}
        onMaskClick={() => {
          setShowPopUp(false);
        }}
      >
        <div
          className="text-center "
          style={{ marginTop: "80px", padding: "20px" }}
        >
          <label className="mb-3">Select Date</label>
          <Form.Control
            type="date"
            max={momentDate(new Date(), "YYYY-MM-DD")}
            onChange={(e) => setSelectedDate(e.target.value)}
            min={semDate?.start_date}
          />
          <br />
          <Button variant="primary" onClick={(e) => onDaySelect()}>
            Set Date
          </Button>
        </div>
      </Popup>
    </>
  );
};
export default TodayTimeTable;
